/* ==========================================================================
   AKRO - Selecteur d'echantillons offerts dans le panier
   --------------------------------------------------------------------------
   Rendu par snippets/akro-sample-picker.liquid. Voir l'en-tete de ce snippet
   pour les regles metier.

   LES PIEGES TRAITES ICI - ne pas "simplifier" sans les relire :

   1. Le drawer porte un @click.stop sur #right-drawer-slot. Un listener
      document en phase bubble ne verrait JAMAIS les clics du drawer.
      -> toute la delegation est en phase CAPTURE (3e argument = true).

   2. Le theme re-rend et "morphe" cart-items a chaque evenement panier.
      Aucun etat n'est garde en JS : l'etat coche vient du HTML rendu par
      Liquid, relu a chaque fois. Aucun binding direct sur les elements.

   3. La logique automatique (precochage, garde-fou) est declenchee par
      `baseline:cart:update`... que nous emettons nous-memes apres chaque
      action. Sans garde, c'est une boucle infinie. Deux verrous : un flag
      `busy` pendant l'aller-retour reseau, et surtout l'attribut de panier
      `_akro_samples` qui memorise que le client a deja ete servi - donc on
      ne represele jamais deux fois.

   4. Une seule API pour tout : /cart/update.js. Son parametre `updates`
      fixe la quantite ABSOLUE par variante, ce qui rend l'operation
      idempotente (rejouer la meme requete ne cree pas de doublon) et permet
      d'envoyer updates + attributes + sections en UNE requete.
      /cart/add.js aurait ajoute une 2e ligne a chaque re-clic.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__akroSamplesReady) return;
  window.__akroSamplesReady = true;

  var ROOT_SEL = '[data-akro-samples]';
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var TOUCHED = '_akro_samples';

  var busy = false;

  function shopRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function getJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().catch(function () { return {}; });
    });
  }

  function fetchCart() {
    return getJSON(shopRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
  }

  /* updates : { variantId: quantite absolue }. attributes : facultatif.
     withSections : demande au serveur de re-rendre les sections panier. */
  function updateCart(updates, attributes, withSections) {
    var payload = {};
    if (updates) payload.updates = updates;
    if (attributes) payload.attributes = attributes;
    if (withSections) {
      payload.sections = SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    return getJSON(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }

  /* Rejoue l'evenement natif du theme : cart-items, cart-footer, le compteur
     et la live region se remettent a jour seuls, sans rechargement. */
  function notifyTheme(data) {
    window.dispatchEvent(
      new CustomEvent('baseline:cart:update', { detail: { response: data } })
    );
  }

  function lock() { document.dispatchEvent(new CustomEvent('baseline:cart:lock')); }
  function unlock() { document.dispatchEvent(new CustomEvent('baseline:cart:unlock')); }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL));
  }

  function setMessage(text) {
    roots().forEach(function (root) {
      var el = root.querySelector('[data-akro-samples-msg]');
      if (el) el.textContent = text || '';
    });
  }

  function setBusy(state) {
    busy = !!state;
    roots().forEach(function (root) {
      if (state) root.setAttribute('data-loading', 'true');
      else root.removeAttribute('data-loading');
    });
  }

  /* --- Lecture de l'etat depuis le panier ---------------------------------- */

  function sampleLines(cart) {
    var handle = 'sample-gift';
    return ((cart && cart.items) || []).filter(function (item) {
      return item && item.handle === handle;
    });
  }

  /* Un parfum 30 ou 100 ML rend le panier eligible. Le 10 ML n'ouvre aucun
     droit (regle client). On lit le titre de variante, "100ML" / "30ML". */
  function isEligible(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      var size = String((item && item.variant_title) || '')
        .toUpperCase()
        .replace(/\s/g, '');
      return size.indexOf('100ML') !== -1 || size.indexOf('30ML') !== -1;
    });
  }

  function wasServed(cart) {
    var attrs = (cart && cart.attributes) || {};
    return String(attrs[TOUCHED] || '') === '1';
  }

  /* Ids des variantes a precocher, lus dans le DOM : le snippet expose les
     noms voulus (data-preselect) et chaque case porte son nom de parfum. */
  function preselectIds() {
    var root = roots()[0];
    if (!root) return [];
    var wanted = String(root.getAttribute('data-preselect') || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);

    var ids = [];
    wanted.forEach(function (name) {
      var box = root.querySelector('[data-akro-sample][data-name="' + name + '"]');
      if (box) ids.push(box.value);
    });
    return ids;
  }

  function maxSamples() {
    var root = roots()[0];
    var n = root ? parseInt(root.getAttribute('data-max'), 10) : 2;
    return isNaN(n) ? 2 : n;
  }

  /* --- Logique automatique ------------------------------------------------- */

  /* Appelee au chargement et apres chaque mise a jour du panier.
     Deux cas seulement, et chacun se desamorce tout seul (voir piege n.3). */
  function reconcile() {
    if (busy) return;

    fetchCart().then(function (cart) {
      var lines = sampleLines(cart);
      var eligible = isEligible(cart);

      /* Garde-fou : plus aucun produit eligible mais des echantillons au
         panier -> on les retire, sinon commande a 0 EUR. On remet aussi le
         drapeau a zero pour que le precochage puisse rejouer si le client
         remet un parfum. */
      if (!eligible && lines.length) {
        var zeros = {};
        lines.forEach(function (line) { zeros[line.variant_id] = 0; });
        setBusy(true);
        lock();
        return updateCart(zeros, buildAttrs(''), true)
          .then(notifyTheme)
          .then(function () { unlock(); setBusy(false); });
      }

      /* Normalisation anti-abus. Le selecteur de quantite est retire de
         l'affichage pour les lignes d'echantillons (cart-items.liquid), mais
         l'API panier, elle, reste ouverte : un simple appel a /cart/add.js
         permettrait sinon de repartir avec 1000 echantillons a 0 EUR.
         On recale donc a chaque lecture du panier :
           - toute ligne d'echantillon repasse a la quantite 1 ;
           - les lignes au-dela du plafond sont supprimees.
         Ce recalage rejoue a chaque chargement de page et a chaque evenement
         panier, donc avant que le client n'atteigne le checkout. */
      var fixes = {};
      var limit = maxSamples();
      lines.forEach(function (line, index) {
        if (index >= limit) {
          fixes[line.variant_id] = 0;
        } else if (line.quantity !== 1) {
          fixes[line.variant_id] = 1;
        }
      });
      if (Object.keys(fixes).length) {
        setBusy(true);
        lock();
        return updateCart(fixes, null, true)
          .then(notifyTheme)
          .then(function () { unlock(); setBusy(false); });
      }

      /* Precochage : panier eligible, aucun echantillon, et le client n'a
         jamais ete servi -> on ajoute reellement Heat + Bake, pour qu'il
         parte avec meme s'il ne touche a rien. */
      if (eligible && !lines.length && !wasServed(cart)) {
        var ids = preselectIds();
        if (!ids.length) return null;
        var adds = {};
        ids.slice(0, maxSamples()).forEach(function (id) { adds[id] = 1; });
        setBusy(true);
        lock();
        return updateCart(adds, buildAttrs('1'), true)
          .then(notifyTheme)
          .then(function () { unlock(); setBusy(false); });
      }

      return null;
    }).catch(function () {
      unlock();
      setBusy(false);
    });
  }

  function buildAttrs(value) {
    var attrs = {};
    attrs[TOUCHED] = value;
    return attrs;
  }

  /* --- Action manuelle ----------------------------------------------------- */

  function toggle(box) {
    if (busy) { box.checked = !box.checked; return; }

    var wanted = box.checked;
    var id = box.value;

    /* Plafond : on ne bloque pas les cases en dur (le HTML est re-rendu a
       chaque fois), on refuse au moment du clic et on rend la case. */
    if (wanted) {
      var checked = document.querySelectorAll('[data-akro-sample]:checked').length;
      if (checked > maxSamples()) {
        box.checked = false;
        setMessage('You can pick up to ' + maxSamples() + ' free samples.');
        return;
      }
    }

    setMessage('');
    setBusy(true);
    lock();

    var updates = {};
    updates[id] = wanted ? 1 : 0;

    /* Des que le client touche une case, il est "servi" : on ne lui
       represele plus rien, meme s'il decoche tout. */
    updateCart(updates, buildAttrs('1'), true)
      .then(function (data) {
        notifyTheme(data);
      })
      .catch(function () {
        setMessage('Something went wrong. Please try again.');
      })
      .then(function () {
        unlock();
        setBusy(false);
      });
  }

  /* --- Fleches de navigation du rail --------------------------------------- */

  function rails() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.akro-samples__list')
    );
  }

  /* Defilement fluide ecrit a la main.

     Ni l option smooth de scrollBy(), ni la propriete CSS scroll-behavior
     ne deplacent le rail ici : au clic il restait strictement immobile. Or l'animation n'est pas
     un ornement dans ce composant - les packshots des 16 echantillons sont
     quasi identiques, un saut instantane ne se lit pas comme un deplacement.
     On anime donc scrollLeft frame par frame, ce qui fonctionne partout.

     Le scroll-snap est neutralise pendant l'animation : il recalerait le rail
     a chaque frame et la rendrait saccadee. */
  function animerVers(rail, cible) {
    var max = rail.scrollWidth - rail.clientWidth;
    cible = Math.max(0, Math.min(cible, max));

    var depart = rail.scrollLeft;
    var delta = cible - depart;
    if (Math.abs(delta) < 1) return;

    var duree = 380;
    var t0 = null;
    rail.style.scrollSnapType = 'none';

    function etape(maintenant) {
      if (t0 === null) t0 = maintenant;
      var p = Math.min((maintenant - t0) / duree, 1);
      /* easeInOutQuad : depart et arrivee amortis, milieu rapide. */
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      rail.scrollLeft = depart + delta * e;

      if (p < 1) {
        window.requestAnimationFrame(etape);
      } else {
        rail.style.removeProperty('scroll-snap-type');
        majFleches(rail);
      }
    }

    window.requestAnimationFrame(etape);
  }

  /* Masque les fleches quand tout tient a l'ecran, les desactive aux bouts.
     Appelee au chargement, au defilement du rail et apres chaque re-rendu du
     panier - le theme remplace le DOM, on ne peut donc rien memoriser. */
  function majFleches(rail) {
    var conteneur = rail.closest('.akro-samples__rail');
    if (!conteneur) return;

    var prev = conteneur.querySelector('[data-akro-samples-nav="prev"]');
    var next = conteneur.querySelector('[data-akro-samples-nav="next"]');
    if (!prev || !next) return;

    /* 2 px de tolerance : les largeurs sont fractionnaires et un rail qui
       tient tout juste se declarerait debordant a chaque rendu. */
    var deborde = rail.scrollWidth > rail.clientWidth + 2;
    var max = rail.scrollWidth - rail.clientWidth;

    /* On MASQUE la fleche inutile au lieu de la griser : au depart il n'y a
       rien a voir a gauche, une fleche grisee n'y aurait aucun sens. */
    prev.hidden = !deborde || rail.scrollLeft <= 2;
    next.hidden = !deborde || rail.scrollLeft >= max - 2;
  }

  function majToutesLesFleches() {
    rails().forEach(majFleches);
  }

  /* --- Delegation en phase CAPTURE (voir piege n.1) ------------------------ */

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest
        ? event.target.closest('[data-akro-samples-nav]')
        : null;
      if (!btn) return;

      var conteneur = btn.closest('.akro-samples__rail');
      var rail = conteneur && conteneur.querySelector('.akro-samples__list');
      if (!rail) return;

      /* On avance d'environ une largeur visible, en gardant une carte de
         reperage a l'ecran. */
      var pas = Math.max(rail.clientWidth * 0.8, 120);
      var sens = btn.getAttribute('data-akro-samples-nav') === 'next' ? 1 : -1;
      /* On pose scrollLeft sans `behavior: 'smooth'` : cette option de
         scrollBy() n'est pas honoree partout et le rail restait alors
         immobile. L'animation vient de `scroll-behavior` en CSS, qui, elle,
         s'applique bien - et se desactive seule en reduced-motion. */
      animerVers(rail, rail.scrollLeft + sens * pas);
      /* On rafraichit l'etat des fleches SANS attendre l'evenement `scroll` :
         un defilement pose par script ne l'emet pas toujours, et les fleches
         restaient alors actives ou grisees a tort. */
      majFleches(rail);
    },
    true
  );

  /* `scroll` ne remonte pas dans l'arbre : on l'ecoute en CAPTURE sur document,
     seule facon de le suivre sans binding direct sur un rail que le theme
     remplace a chaque rendu. */
  document.addEventListener(
    'scroll',
    function (event) {
      var el = event.target;
      if (el && el.classList && el.classList.contains('akro-samples__list')) {
        majFleches(el);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var box = event.target;
      if (!box || !box.matches || !box.matches('[data-akro-sample]')) return;
      toggle(box);
    },
    true
  );

  /* L'ouverture / fermeture du bloc est geree par assets/akro-cart-accordion.js
     depuis le 2026-09-24 (commun avec le code promo). */

  /* --- Cycle de vie -------------------------------------------------------- */

  /* Le theme emet TROIS evenements panier distincts, et il faut les ecouter
     tous les trois. En particulier `cartqtychange` : c'est lui - et non
     `update` - qui part quand une ligne est supprimee via le bouton du panier.
     N'ecouter que `update` laissait les echantillons en place quand le client
     retirait son parfum, donc une commande entierement gratuite. */
  ['baseline:cart:update',
   'baseline:cart:cartqtychange',
   'baseline:cart:afteradditem'].forEach(function (name) {
    window.addEventListener(name, function () {
      /* Laisse le theme finir de morpher le DOM avant de relire le panier. */
      window.setTimeout(reconcile, 0);
      window.setTimeout(majToutesLesFleches, 0);
    });
  });

  /* Les fleches se calculent sur la largeur REELLE du rail. Au chargement,
     le tiroir est ferme : largeur nulle, les deux fleches sont masquees. Il
     faut donc recalculer quand le rail devient visible - ouverture du tiroir
     (`cart-will-open`, emis par le theme), ouverture du bloc echantillons -
     et quand sa largeur change (rotation de l'ecran). Deux passes : tout de
     suite, puis apres l'animation d'ouverture du tiroir (~0,4 s). */
  function majFlechesBientot() {
    window.setTimeout(majToutesLesFleches, 0);
    window.setTimeout(majToutesLesFleches, 450);
  }

  document.addEventListener('cart-will-open', majFlechesBientot);
  window.addEventListener('resize', majFlechesBientot);
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest('[data-akro-acc-toggle="samples"]')) {
        majFlechesBientot();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reconcile(); majToutesLesFleches(); });
  } else {
    reconcile();
    majToutesLesFleches();
  }
})();
